import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import ColorSelect, {
    ColorSelectType,
} from "organisms/my-link/my-bookmarks/color-select";
import React, { useRef } from "react";
import { useState } from "react";
import { CustomColorUtils } from "utilities/custom-color-utils";
import { UserBookmarkColors } from "utilities/enumerations/user-bookmark-colors";
import useOutsideClick from "utilities/hooks/use-outside-click";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-my-bookmark-mini-color-select";
interface MyBookmarkMiniColorSelectProps {
    isEditing: boolean;
    color: UserBookmarkColors;
    onColorChange: (newColor: number) => Promise<void>;
}
const MyBookmarkMiniColorSelect = ({
    color,
    onColorChange,
    isEditing,
}: MyBookmarkMiniColorSelectProps) => {
    const [isSelectingColor, setIsSelectingColor] = useState(false);
    const colorSelectRef = useRef<HTMLDivElement>(null);

    useOutsideClick(colorSelectRef, () => {
        setIsSelectingColor(false);
    });

    const handleUserBookmarkColorChanged = async (newColor: number) => {
        await onColorChange(newColor);
        setIsSelectingColor(false);
    };

    const colorClass = CustomColorUtils.getClassModifier(
        UserBookmarkColors,
        color,
        ColorSelectType.Bookmark
    );

    const BookmarkIcon = () => (
        <Icon cssClassName={colorClass} type={Icons.Bookmark} />
    );

    return (
        <div className={CSS_CLASS_NAME}>
            {isEditing ? (
                <>
                    <Button
                        onClick={() => setIsSelectingColor(true)}
                        cssClassName={`${CSS_CLASS_NAME}__button`}
                        size={ButtonSizes.XSmall}
                        style={ButtonStyles.None}
                        accessibleText={t("changeBookmarkColor")}>
                        <BookmarkIcon />
                        <Icon type={Icons.ChevronDown} />
                    </Button>
                    {isSelectingColor && (
                        <div ref={colorSelectRef}>
                            <ColorSelect
                                showLabel={false}
                                isOpenByDefault
                                enumObject={UserBookmarkColors}
                                onChange={handleUserBookmarkColorChanged}
                                type={ColorSelectType.Bookmark}
                                value={color}
                            />
                        </div>
                    )}
                </>
            ) : (
                <BookmarkIcon />
            )}
        </div>
    );
};

export default MyBookmarkMiniColorSelect;
